import { configureStore } from "@reduxjs/toolkit";
import { setupListeners } from "@reduxjs/toolkit/query";
import { gemoApi } from "./gemo/gemo";
import { oncoApi } from "./onco/onco";
import { authApi } from "./Auth/auth";
import authSlice from "./Auth/authSlice";
import { serviceApi } from "./service/service";

const store = configureStore({
  reducer: {
    authSlice,
    [authApi.reducerPath]: authApi.reducer,
    [gemoApi.reducerPath]: gemoApi.reducer,
    [oncoApi.reducerPath]: oncoApi.reducer,
    [serviceApi.reducerPath]: serviceApi.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(
      authApi.middleware,
      gemoApi.middleware,
      oncoApi.middleware,
      serviceApi.middleware
    ),
  devTools: true,
});

export default store;
setupListeners(store.dispatch);
